// src/components/mobile/MobileTopBar.js
//
// iPhone-only top bar — replaces the desktop Toolbar children on xs.
// Revolut-style: greeting line + single profile avatar + single bell.
// No inline search, no font picker, no offline chip — those live on
// desktop only.
//
// Rendered inside the AppBar's Toolbar by Layout.js when isMobile is
// true. The desktop chrome (search box, font/theme/STT icons, profile
// pill) is hidden via `display: { xs: 'none', md: 'flex' }` so this
// file is the SOLE mobile chrome.

import React from 'react';
import { Avatar, Box, IconButton, Typography } from '@mui/material';
import NotificationCenter from '../NotificationCenter';

const greetingFor = (hour) => {
  if (hour < 5) return 'مساء الخير';
  if (hour < 12) return 'صباح الخير';
  if (hour < 18) return 'مساء الخير';
  return 'مساء الخير';
};

const MobileTopBar = ({ displayName, userInitial, onProfileClick }) => {
  const first = (displayName || '').split(' ').slice(0, 2).join(' ');
  const hour = new Date().getHours();

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      gap: 1,
      px: 0,
    }}>
      <IconButton
        onClick={onProfileClick}
        sx={{ p: 0.25 }}
        aria-label="الحساب"
      >
        <Avatar sx={(t) => ({
          width: 34, height: 34,
          bgcolor: t.palette.sacred.primary,
          color: t.palette.sacred.onPrimary,
          fontFamily: 'var(--sacred-font-body)',
          fontSize: '0.9rem',
          border: `1.5px solid ${t.palette.sacred.primaryFixed}66`,
        })}>
          {userInitial}
        </Avatar>
      </IconButton>

      <Box sx={{ minWidth: 0, flex: 1, display: 'flex', alignItems: 'baseline', gap: 0.75 }}>
        <Typography
          noWrap
          sx={{
            fontFamily: 'var(--sacred-font-display)',
            fontSize: '0.98rem',
            fontWeight: 700,
            color: 'sacred.onSurface',
            minWidth: 0,
          }}
        >
          {first || greetingFor(hour)}
        </Typography>
        <Typography sx={{
          fontFamily: 'var(--sacred-font-label)',
          fontSize: '0.62rem',
          color: 'sacred.onSurfaceVariant',
          letterSpacing: '0.02em',
          flexShrink: 0,
          opacity: 0.7,
        }}>
          {greetingFor(hour)}
        </Typography>
      </Box>

      <NotificationCenter />
    </Box>
  );
};

export default MobileTopBar;
